export const GET_ALL_ABSENT_PERSONS = "GET_ALL_ABSENT_PERSONS"
export const CREATE_ABSENT_PERSONS = "CREATE_ABSENT_PERSONS"
export const UPDATE_ABSENT_PERSONS = "UPDATE_ABSENT_PERSONS"
export const DELETE_ABSENT_PERSONS = "DELETE_ABSENT_PERSONS"
